import { memo } from 'react'
import { OptionTemplate } from 'components/ui/selects/OptionTemplate'
import { Text } from 'components/ui/Text'
import { SuggestionCompanyItem } from 'schema'

import { IOptionProps } from './types'

import s from './SelectCompany.module.less'

// @ts-ignore
export const SelectCompanyOption = memo<IOptionProps<SuggestionCompanyItem>>(function SelectCompanyOption({
  value,
  ...props
}) {
  return (
    // @ts-ignore
    <OptionTemplate {...props} isSelected={undefined} value={value}>
      <div className={s.optionLink} data-test-id="select--company--option">
        {value.value}
        <Text block className={s.optionLinkInn} color="placeholder">
          {value.inn}
        </Text>
      </div>
    </OptionTemplate>
  )
})
